module.exports = "/_next/static/images/FrameMobile-40d9008bc0c8393b35969e0a9a5e3f61.webp";